import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BlockIcon from "@mui/icons-material/Block";
import PersonIcon from "@mui/icons-material/Person";

const OBSERVACIONES_CONFIG = [
  { campo: "obs_reclamo", label: "Reclamo", icon: WarningIcon, color: "error.main" },
  { campo: "desc_motivo_rechazo", label: "Rechazo", icon: CancelIcon, color: "error.main" },
  { campo: "obs_pospuesto", label: "Posposición", icon: ScheduleIcon, color: "warning.main" },
  { campo: "obs_anulado", label: "Anulación", icon: BlockIcon, color: "error.main" },
];

// Detalle pensado para el ancho angosto de una tarjeta de grilla (no el
// panel de detalle original, hecho para una fila de tabla ancha). No repite
// dirección/carga/fecha porque ya se ven en el cuerpo de la tarjeta; acá
// quedan el chofer asignado, las observaciones y los motivos.
const DetalleTarjetaPedido = ({ pedido }) => {
  const observaciones = OBSERVACIONES_CONFIG.map((config) => ({
    ...config,
    valor: pedido[config.campo],
  })).filter((o) => o.valor);

  if (observaciones.length === 0 && !pedido.observaciones && !pedido.nombre_apellido) return null;

  return (
    <Box sx={{ mt: 1, pt: 1, borderTop: "1px dashed", borderColor: "divider" }}>
      {pedido.nombre_apellido && (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5 }}>
          <PersonIcon sx={{ fontSize: 16, color: "text.secondary", flexShrink: 0 }} />
          <Typography variant="body2" color="text.secondary">
            {pedido.nombre_apellido}
          </Typography>
        </Stack>
      )}

      {observaciones.map(({ campo, label, icon: Icono, color, valor }) => (
        <Stack key={campo} direction="row" spacing={0.5} alignItems="flex-start" sx={{ mb: 0.5 }}>
          <Icono sx={{ fontSize: 16, color, mt: "2px", flexShrink: 0 }} />
          <Typography variant="body2" color="text.secondary">
            <Typography component="span" variant="body2" fontWeight={700} sx={{ color }}>
              {label}:
            </Typography>{" "}
            {valor}
          </Typography>
        </Stack>
      ))}

      {pedido.observaciones && (
        <Typography variant="body2" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
          {pedido.observaciones}
        </Typography>
      )}
    </Box>
  );
};

export default DetalleTarjetaPedido;
